export enum RoleStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const RoleStatusOptions = [
  {
    label: "Active",
    value: RoleStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: RoleStatus.INACTIVE,
  },
];
